import { createContext, useContext } from 'react';

import { ICause } from 'core/Api';

// Create a context to provide the cause data to children
type CauseContextType = {
  cause: ICause;
  showStoreTab: boolean;
  showFundraisersTab: boolean;
  showTicketsTab: boolean;
};

const CauseContext = createContext<CauseContextType | null>(null);

// Hook to access the cause data in children components
const useCausePageContext = () => {
  const context = useContext(CauseContext);
  if (!context) {
    throw new Error('useCausePageContext must be used within a CauseProvider');
  }
  return context;
};

export { CauseContext, useCausePageContext };
